import { BehaviorSubject, Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root"
})
export class AdvTradingProvisionerService {
	private isLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private showErrorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();
	public showError$: Observable<boolean> = this.showErrorSubject.asObservable();

	public setLoading(isLoading: boolean): void {
		this.isLoadingSubject.next(isLoading);
	}

	public setShowError(showError: boolean): void {
		this.showErrorSubject.next(showError);
	}
}
